import { toast } from 'react-toastify';

import { ITraderWallet, useChangeTraderWalletStatusMutation } from '@entities/trades/wallet';
import ModalConfirm from '@features/modal-confirm';
import { useModal } from '@shared/components/Modal';
import { isApiError } from '@shared/types/fetch-data';

interface IProps<T> {
  wallet: T;
  refetch: () => void;
}

export const FreezeTraderWallet = <T extends ITraderWallet>({ wallet, refetch }: IProps<T>) => {
  const [changeTraderWalletStatus] = useChangeTraderWalletStatusMutation();
  const { closeModal } = useModal();

  const handleConfirm = async () => {
    const result = await changeTraderWalletStatus({
      id: wallet.id,
      status: 'frozen',
      reason: 'Frozen by admin',
    });

    if ('data' in result) {
      closeModal();
      refetch();
    }

    if ('error' in result && isApiError(result.error)) {
      toast.error(result.error.data.message);
    }
  };

  return (
    <ModalConfirm
      title='Freeze Wallet'
      message={`Are you sure you want to freeze wallet #${wallet.id}?`}
      onConfirm={handleConfirm}
      onCancel={closeModal}
    />
  );
};
